import Repository, { secret } from '@/repository';

export function superAdminSession() {
    try {
        return JSON.parse(localStorage.getItem('tnjtek_admin') || 'null');
    } catch (error) {
        return null;
    }
}

export async function superAdminRequest(path, data) {
    const session = superAdminSession();
    const response = await Repository.request({
        url: `superAdmin/${path}`,
        method: data === undefined ? 'get' : 'post',
        data,
        timeout: 30000,
        headers: {
            Secret: secret,
            session: JSON.stringify({ id: session && session.id, token: session && session.token, role: 'admin' })
        }
    });
    if (response.data.error) throw new Error(response.data.msg || 'Unable to load Super Admin');
    return response.data;
}

export async function guardSuperAdmin(to, from, next) {
    if (!to.matched.some(record => record.meta.superAdmin)) return next();
    const session = superAdminSession();
    if (!session || Number(session.id) !== 1 || !session.token) return next({ name: 'AdminDashboard', replace: true });
    try {
        await superAdminRequest('session');
        next();
    } catch (error) {
        next({ name: 'AdminDashboard', replace: true });
    }
}
